import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import startOfToday from "date-fns/startOfToday";
import * as Yup from "yup";
const schema = () => Yup.object().shape({
  description: Yup.string().required("At least one character required"),
  employeeReferenceId: Yup.string().required(),
  startDate: Yup.date().min(startOfToday()).required(),
  startTime: Yup.string().required().matches(/^[0-9]{2}:[0-9]{2}$/, {
    message: "Wrong time format"
  }),
  endTime: Yup.string().required().matches(/^[0-9]{2}:[0-9]{2}$/, {
    message: "Wrong time format"
  }),
  workRelated: Yup.boolean()
});
const getInitialFormData = (blocker) => ({
  description: (blocker == null ? void 0 : blocker.description) || "Blocker",
  employeeReferenceId: (blocker == null ? void 0 : blocker.employeeReferenceIds[0]) ?? "",
  startDate: (blocker == null ? void 0 : blocker.startDate) ? new Date(blocker.startDate) : /* @__PURE__ */ new Date(),
  startTime: (blocker == null ? void 0 : blocker.startTime) ?? "",
  endTime: (blocker == null ? void 0 : blocker.endTime) ?? "",
  workRelated: (blocker == null ? void 0 : blocker.workRelated) ?? false
});
const useBlockerForm = (blocker) => {
  const form = useForm({
    defaultValues: getInitialFormData(blocker),
    resolver: yupResolver(schema()),
    mode: "onChange",
    reValidateMode: "onChange"
  });
  return { form };
};
export {
  useBlockerForm
};
